import { Pipe, PipeTransform } from '@angular/core';
import { ScheduleFrequency } from '../../enums/data.enums';
import { EnumUtilities } from '../../utilities/enum.utilities';

// Renders an invoice schedule's frequency, appending the month count for Custom, e.g. "Custom - Every 3 months".
@Pipe({
  name: 'scheduleFrequency'
})
export class ScheduleFrequencyPipe implements PipeTransform {

  transform(frequency: ScheduleFrequency | undefined, customFrequencyMonths?: number | null): string {
    const label = EnumUtilities.convertToLabel(frequency);
    if (frequency === ScheduleFrequency.Custom && customFrequencyMonths) {
      return `${label} - Every ${customFrequencyMonths} months`;
    }
    return label;
  }

}
